/**
 * The possible contexts are:
 *  - default: the default text message in a version
 *  - feedback: a message from feedback feature in share feedback plugin 
 *  - upload-version: a message from upload version feature in share feedback plugin
 */
export enum VersionMessageContext {
    DEFAULT = 'default',
    FEEDBACK = 'feedback', // a message from feedback feature in share feedback plugin 
    UPLOAD_VERSION = 'upload-version', // a message from upload version feature in share feedback plugin
}